import { useState } from 'react';

const HATCHING =
  'repeating-linear-gradient(45deg, var(--td-primary-soft) 0 1px, transparent 1px 14px)';

// A cross-origin image is retried without CORS (it then cannot be drawn on a
// canvas, but still displays) before it counts as broken.
export function useImageFallback() {
  const [broken, setBroken] = useState(false);
  const onError = (e) => {
    if (e.currentTarget.hasAttribute('crossorigin')) {
      e.currentTarget.removeAttribute('crossorigin');
      return;
    }
    setBroken(true);
  };
  return [broken, onError];
}

// Stands in for a missing or broken photo, sized by the caller like the image
// it replaces.
export default function ExportImagePlaceholder({
  tinted = false,
  label,
  small = false,
  className = '',
}) {
  return (
    <div
      className={[
        'flex flex-col items-center justify-center gap-3',
        tinted
          ? 'bg-[var(--td-primary-faint)]'
          : 'bg-[var(--td-paper-secondary)]',
        className,
      ].join(' ')}
      style={{ backgroundImage: HATCHING }}
    >
      <i
        aria-hidden
        className={`fa-light fa-image text-[var(--td-primary)] ${
          small ? 'text-xl' : 'text-3xl'
        }`}
      />
      {label && (
        <div className="text-2xs font-semibold uppercase tracking-[0.2em] text-[var(--td-primary)]">
          {label}
        </div>
      )}
    </div>
  );
}
